import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import messages from '../messages';

export const EditButton = ({ categoryId, name = '', setNameValue, setIdInEditMode }) => {
  const onClickCallback = useCallback(() => {
    setIdInEditMode(categoryId);
    setNameValue(name);
  }, [categoryId, name, setNameValue, setIdInEditMode]);

  return (
    <Button onClick={onClickCallback} theme='link'>
      <FormattedMessage {...messages.editCategoryButton} />
    </Button>
  );
};

EditButton.propTypes = {
  categoryId: PropTypes.string.isRequired,
  name: PropTypes.string,
  setNameValue: PropTypes.func.isRequired,
  setIdInEditMode: PropTypes.func.isRequired,
};
